import CustomTooltipComponent from './CustomTooltip';

export { CustomTooltip } from './CustomTooltip';
export type { CustomTooltipProps, CustomTooltipPlacement } from './CustomTooltip';
export default CustomTooltipComponent;
